import { createFileRoute } from "@tanstack/react-router";
import { seo, breadcrumbScript } from "@/lib/seo";
import { LegalCard, LegalPage } from "@/components/app/legal-page";

const DESC =
  "Terms and conditions for using The Quantum Minds study platform, including content use, subscriptions and account rules.";

export const Route = createFileRoute("/terms")({
  head: () => ({
    ...seo({
      title: "Terms & Conditions — The Quantum Minds",
      description: DESC,
      path: "/terms",
    }),
    scripts: [
      breadcrumbScript([
        { name: "Home", path: "/" },
        { name: "Terms & Conditions", path: "/terms" },
      ]),
    ],
  }),
  component: TermsPage,
});

function TermsPage() {
  return (
    <LegalPage
      title="Terms & Conditions"
      intro="By using The Quantum Minds, you agree to the terms and conditions set out below."
    >
      <LegalCard
        heading="About the Platform"
        points={[
          "The Quantum Minds is an independently operated educational platform.",
          "The platform is intended for educational and exam-preparation purposes only.",
        ]}
      />
      <LegalCard
        heading="About the Founder"
        points={[
          "The Quantum Minds was founded and is independently operated by Aryan Singh, a young education entrepreneur focused on building practical, technology-driven tools for students.",
          "The project is independently built and operated with a strong focus on helping students prepare for competitive examinations in a structured, efficient, and accessible way.",
          "The Quantum Minds is not affiliated with or officially associated with NTA, JEE authorities, CBSE, or any coaching institute unless explicitly stated.",
        ]}
      />
      <LegalCard
        heading="Premium Subscriptions"
        points={[
          "Premium subscriptions are personal and non-transferable. Account sharing is not permitted.",
          "Subscription access is activated only after successful payment verification through the integrated payment system.",
          "Subscription plans provide access to the features and duration displayed on the pricing page at the time of purchase.",
        ]}
      />
      <LegalCard
        heading="Simulation Credits"
        points={[
          "The ₹35 1-month plan includes 300 simulations at no additional charge.",
          "Other eligible plans may provide an optional Enable 300 Simulations — +₹29 add-on during checkout.",
          "The ₹29 simulation add-on provides an additional 300 simulations.",
          "The simulation add-on is available only for eligible subscription plans and is not applicable to the ₹35 1-month plan because 300 simulations are already included in that plan.",
          "If a user purchases additional simulations and has unused simulation credits remaining when the current subscription expires, the unused simulation credits will carry forward when the user purchases another eligible subscription.",
          "Simulation credits are exclusively for the simulation feature and cannot be exchanged for cash or transferred to another account.",
          "Additional 300-simulation add-ons may be purchased again when available under the user's eligible plan.",
        ]}
      />
      <LegalCard
        heading="Coupon Codes & Offers"
        points={[
          "Coupon codes and promotional offers are subject to their stated validity period, eligibility criteria, minimum transaction amount, maximum discount, and usage limits.",
        ]}
      />
      <LegalCard
        heading="Acceptable Use"
        points={[
          "Users must not misuse, copy, redistribute, resell, or attempt to exploit platform content or premium features.",
        ]}
      />
      <LegalCard
        heading="Changes to Features & Policies"
        points={[
          "The Quantum Minds may modify features, pricing, plans, or policies in the future. Such changes will apply prospectively and will not invalidate an already purchased subscription period.",
        ]}
      />
      <LegalCard
        heading="Account Suspension"
        points={[
          "Any attempt to manipulate payments, coupon offers, subscription activation, simulation credits, or other platform systems may result in suspension or termination of access.",
        ]}
      />
    </LegalPage>
  );
}